import React from 'react'
import { Alert, Box, Typography, useTheme } from '@mui/material'

import { PhoneVerificationProps, PHONE_VERIFICATION } from './types'
import VerificationCode from '../VerificationCode/VerificationCode'
import { formatPhone } from '../../services/formhelper.service'

const PhoneVerification: React.FC<PhoneVerificationProps> = ({
  phone,
  phoneNewCode,
  onSubmitCode,
  isError,
  isInvalid,
  isLoading
}) => {
  const theme = useTheme()
  const handleSubmit = (code: string): void => {
    onSubmitCode({ type: PHONE_VERIFICATION, code })
  }

  return (
    <>
      <Box>
        <Typography
          component="div"
          variant="body1"
          textAlign="center"
          style={{
            marginBottom: theme.spacing(2)
          }}
        >
          Enter the verification code sent to <b>{formatPhone(phone)}</b>
        </Typography>
        <VerificationCode
          type="numeric"
          placeholder="000-000"
          isInvalid={isInvalid}
          onGetNewCode={phoneNewCode}
          onSubmit={handleSubmit}
          isLoading={isLoading}
        />
      </Box>
      {isError && (
        <Box sx={{ marginTop: 2 }}>
          <Alert severity="error">An error occurred.</Alert>
        </Box>
      )}
    </>
  )
}

export default PhoneVerification
